// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperImages-cls1__cc59ecad86b71f14c1e3{/*!*/}.PaperImages-cls2___71b21ec214ef76081ad{padding:24px 16px;padding:var(--spacing-sm-24, 24px) var(--spacing-sm-16, 16px)}.PaperImages-cls2___71b21ec214ef76081ad.PaperImages-variant-dense___8d1b94b62c2ba96cffc{border-radius:8px;border:1px solid #dddde2;border:1px solid var(--stroke-light, #dddde2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperImages-cls1__cc59ecad86b71f14c1e3",
	"cls2": "PaperImages-cls2___71b21ec214ef76081ad PaperImages-cls1__cc59ecad86b71f14c1e3",
	"variant-dense": "PaperImages-variant-dense___8d1b94b62c2ba96cffc"
};
export default ___CSS_LOADER_EXPORT___;
